module.exports = __webpack_public_path__ + "05e887ca4615516a69e36cb783e4cc2c.svg";